import styled from "styled-components/macro";

export const StyledMainContainer = styled.div`
  width: 544px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  margin: 40px auto;
  background: #ffffff;
  border: 1px solid #ebedee;
  border-radius: 4px;
`;

export const StyledHeader = styled.header`
  & img {
    margin-bottom: 16px;
  }
  & h3 {
    font-weight: 600;
    font-size: 40px;
    line-height: 60px;
    color: #575e68;
    margin-bottom: 16px;
  }
  
  & h1 {
    color: #575e68;
  }
  & p {
    font-size: 21px;
    line-height: 31px;
    color: #575e68;
  }
`;

export const StyledIFrame = styled.iframe`
  display: block;
  margin: 40px auto;
  ${"" /* width: 480px;
  height: 269px; */}
  background: linear-gradient(
      0deg,
      rgba(28, 34, 96, 0.17),
      rgba(28, 34, 96, 0.17)
    );
  border: 1px solid #e7ebee;
  border-radius: 16px;
`;

export const StyledForm = styled.form`
  width: 100%;
  font-size: 16px;
  line-height: 24px;
  text-align: center;

  color: #575e68;
`;
export const StyledCheckBox = styled.div`
  display: flex;
  align-items: baseline;
  input {
    margin-right: 10px;
  }
  margin-bottom: 40px;
  a {
    text-decoration: none;
    color: #939dd6;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const StyledButton = styled.button`
  width: 100%;
  background: #6270c6;
  border: 1px solid #939dd6;
  border-radius: 4px;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: #fcfcfd;
  padding: 16px;
  &:hover {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }
  opacity: ${(props) => (props.disabled ? 0.2 : 1)};
`;
